<template>
  <div class="c-container">
    <TheHeader />
    <div class="c-container__content">
      <router-view></router-view>
    </div>
  </div>
  <div id="modals"></div>
</template>

<script>
import TheHeader from "@/components/TheHeader";
import checkOnlineSetup from "@/infrastructure/check-online-setup";

export default {
  name: "App",
  components: {
    TheHeader,
  },
  setup() {
    return {
      ...checkOnlineSetup(),
    };
  },
};
</script>
